"use client";

import React from "react";
import { PORTAL_THEME } from "../../lib/portal_theme";
import AdminGate from "./orders/AdminGate";

const T = PORTAL_THEME;

const LINKS = [
  { href: "/admin/orders", title: "Full Service Orders", body: "Work artist-made orders: review requests, upload finished files, send to the customer." },
  { href: "/admin/nil", title: "NIL Payouts", body: "Athlete and team stores: what each is owed, their payout details, and recording a payout." },
  { href: "/admin/accounts", title: "Accounts", body: "Every customer account. Open one to see — and work in — their saved designs." },
  { href: "/admin/backgrounds", title: "Background Images", body: "Upload, order and remove the background catalog." },
];

// Sales admin hub (sales@recruitgraphics.com — see getFullServiceAdmin).
export default function AdminHomePage() {
  return (
    <AdminGate returnTo="/admin" title="Admin">
      <div style={{ minHeight: "100vh", fontFamily: T.fontFamily, color: T.text }}>
        <div style={{ maxWidth: 720, margin: "0 auto", padding: "40px 20px" }}>
          <h1 style={{ fontSize: 24, fontWeight: 800, margin: "0 0 20px" }}>Admin</h1>
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            {LINKS.map((l) => (
              <a key={l.href} href={l.href}
                style={{ display: "block", padding: "18px 20px", borderRadius: 0, textDecoration: "none", color: T.text,
                  background: T.cardBackground, border: T.cardEdge }}>
                <div style={{ fontWeight: 800, fontSize: 16 }}>{l.title} →</div>
                <div style={{ fontSize: 13, color: T.textMuted, marginTop: 4 }}>{l.body}</div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </AdminGate>
  );
}
